///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2024 - 2024
//                           Coyote Logistics L.L.C.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import React, { Component } from "react";
import { formatDateAndTime } from "../../../helpers/formatDateAndTime";
import { division } from "../../../helpers/types";
import getCurrency from "../../../helpers/getCurrency";
import messages from "../../../helpers/messages";

export class RateHistory extends Component {
    render() {
        const { carrierRateHistory } = this.props;
        const hasRateHistory = carrierRateHistory?.length > 0;

        if (hasRateHistory === false) {
            return null;
        }

        const HeaderCell = ({ columnName }) => {
            return <th>{columnName}</th>;
        };

        const BodyCell = ({ value, children, maxWidth }) => (
            <td className="body-cell" style={{ maxWidth: maxWidth }}>
                {value || children}
            </td>
        );

        return (
            <div className="mt-12 pl-8">
                <table>
                    <thead>
                        <tr className="border-bottom-grey">
                            <HeaderCell columnName={messages.user.defaultMessage} />
                            <HeaderCell columnName={messages.dateAndTime.defaultMessage} />
                            <HeaderCell columnName={messages.rate.defaultMessage} />
                        </tr>
                    </thead>
                    <tbody>
                        {carrierRateHistory?.map((x, index) => {

                            return (
                                <tr key={index} className="border-bottom-grey">
                                    <BodyCell value={x.userName} maxWidth={200} />
                                    <BodyCell value={formatDateAndTime(x.createDateUTC + "Z", division.coy)} maxWidth={125} />
                                    <BodyCell value={`${getCurrency(division.coy)}${x.carrierRate}`} maxWidth={70} />
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            </div>
        );
    }
};

export default RateHistory;
